import * as React from "react";
import { Link } from "react-router-dom";
import { useContext } from "src/ReactTS";
import { CloseMenuMobile, LogoHeader, MenuMobile } from "../../common/icons";
import MenuList from "../../common/MenuList";
import { AuthContext } from "src/components/context/AuthContext";
import * as MigalhasLogo from "src/assets/logos/migalhas.png";

import "./index.scss";

const Header: React.SFC<any> = props => {
  const { currentEmail, currentUser, isClient } = useContext(AuthContext);

  const HeaderMigalhas = () => {
    return (
      <li className="decode-item decode-item-no-border ">
        <a href="http://www.migalhas.com.br" target="_blank">
          <img style={{ paddingLeft: "30px" }} src={MigalhasLogo} height="50px" alt="Migalhas" />
        </a>
      </li>
    );
  };

  const handleMenu = () => {
    // declarating body
    const body = document.querySelector("body");

    // toggling menu
    body.classList.toggle("decode-overlay");
    body.classList.toggle("decode-overlay--menu");
  };
  const isMigalhas = () => {
    return window.location.pathname.includes("/migalhas");
  };

  return (
    <header className="decode-header">
      <div className="decode-container decode-container-flex decode-container-flex--spaced decode-container-flex--row">
        {currentEmail && currentUser && isClient() ? (
          <Link to="/">
            <LogoHeader styles={{ display: "inline-block", verticalAlign: "middle" }} />
          </Link>
        ) : (
          <a href="https://precatoriosbrasil.com/">
            <LogoHeader styles={{ display: "inline-block", verticalAlign: "middle" }} />
          </a>
        )}

        <nav className="decode-header-navigation">
          <CloseMenuMobile />

          {isMigalhas() && <HeaderMigalhas />}

          <MenuList items={props.NavigationItems} />
        </nav>

        <MenuMobile onClick={handleMenu} />
      </div>
      <div className="decode-overlay-layer" onClick={handleMenu} />
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/template/header/index.tsx